<script>
export default {
  name: "ProductImage",

  data() {
    return {
      smallWindow: false,
    };
  },

  props: {
    image: {
      default: {},
      type: Object,
    },

    index: {
      default: null,
      type: Number,
    },
  },

  mounted() {
    this.setSmallWindow();
    window.addEventListener("resize", this.setSmallWindow);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setSmallWindow);
  },

  computed: {
    backgroundImageSmall() {
      return `background-image: url(${this.image.fields.file.url}?w=1000&fl=progressive)`;
    },

    backgroundImageLarge() {
      return `background-image: url(${this.image.fields.file.url}?w=2000&fl=progressive)`;
    },
  },

  methods: {
    setSmallWindow() {
      this.smallWindow = window.innerWidth <= 1024;
    },
  },
};
</script>

<template>
  <div v-if="smallWindow" class="image" :style="backgroundImageSmall" />
  <div v-else class="image" :style="backgroundImageLarge" />
</template>

<style lang="scss" scoped>
.image {
  width: 100%;
  height: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
